module.exports = __webpack_public_path__ + "img/sup_withdraw_mtpay3.1f1e9859.jpg";